import React from "react";
import moment from "moment";
import { Typography } from "@plum-xoxo/admin-dsm";
const Date = ({ value }) => {
  return (
    <div
      style={{
        whiteSpace: "nowrap",
      }}
      className="d-inline-block"
    >
      {value && value !== "0000-00-00" ? (
        <>
          <Typography color="dark" shade="c300" className="mb-0">
            {moment(value, "YYYY-MM-DD").format("MMM D, YYYY")}
          </Typography>
          {value.length > 10 ? (
            <Typography color="dark" shade="c200" className="mb-0">
              {moment(value).format("HH:mm:ss")}
            </Typography>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Date;
